<template>
  <div v-if="visible" class="cookie-consent">
    <div class="cookie-content">
      <h4>We use cookies 🍪</h4>
      <p>
        We use cookies to improve your experience, analyze traffic, and personalize content.
        By clicking “Accept All”, you consent to our use of cookies.
      </p>

      <div class="cookie-actions">
        <button class="reject" @click="rejectCookies">Reject All</button>
        <button class="accept" @click="acceptCookies">Accept All</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieConsent",
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      this.visible = true;
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem("cookie_consent", "accepted");
      this.visible = false;
      this.$emit("accepted");
    },
    rejectCookies() {
      localStorage.setItem("cookie_consent", "rejected");
      this.visible = false;
      this.$emit("rejected");
    }
  }
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 20px;
  right: 20px;
  max-width: 360px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  font-family: Arial, sans-serif;
}

.cookie-content {
  padding: 16px;
}

.cookie-content h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.cookie-content p {
  font-size: 14px;
  color: #555;
  margin-bottom: 14px;
}

.cookie-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.cookie-actions button {
  flex: 1;
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
}

.cookie-actions .accept {
  background-color: #2e7d32;
  color: #fff;
}

.cookie-actions .reject {
  background-color: #e0e0e0;
  color: #333;
}
</style>
